import React, { useEffect, useLayoutEffect, useState } from "react";
import { Button, FloatButton, Input, Modal, Popover, Table } from "antd";
// import { useDeleteOrder, useMyOrderList, useOrderList, useOrderStatus } from '../../../api/order';
import { useNavigate } from "react-router-dom";
import { getStatusColor } from "../../../util/statusColor";
// import AdminUdateOrderModal from '../../modals/order/AdminUdateOrderModal';
import { AuthContextValue, useAuth } from "../../../providers/AuthProvider";
import TableAction from "../../TableAction";
import { useGetOrderStatusCount, useMyOrderList } from "../../../api/order";
import TableFilter from "../../TableFilter";
import { useGetStatusCount } from "../../../hooks/useGetStatusCount";
import { MoreOutlined, PlusOutlined } from "@ant-design/icons";

type OffTakerOrdersTableProps = {
  searchText: string;
};

const OffTakerOrdersTable = () => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState<any[]>([]);
  const { user } = useAuth() as AuthContextValue;
  const [open, setOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<string>();
  const [selectedFilterIndex, setSelectedFilterIndex] = useState(0);
  const [searchText, setSearchText] = useState<string>("");
  const {
    data: orders,
    isLoading,
    refetch,
  } = useMyOrderList({ status: selectedStatus, search: searchText });
  const { data: statuses } = useGetOrderStatusCount();

  const [deleteOpen, setdeleteOpen] = useState(false);
  const [deleteSelectedId, setdeleteSelectedId] = useState("");

  const ordersColumn = [
    // {
    //   title: 'No.',
    //   width: 20,
    //   render: (text: string, record: any, index: number) => <b>#{index + 1}</b>
    // },
    {
      dataIndex: "product",
      title: "Product",
    },
    {
      dataIndex: "startingDate",
      title: "Start date",
    },
    {
      dataIndex: "dueDate",
      title: "Due date",
    },
    {
      dataIndex: "orderAmount",
      title: "Quantity (qt)",
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (text: string, record: any) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "80%",
              paddingTop: 6,
              paddingBottom: 6,
              borderRadius: 8.5,
              color: getStatusColor(text),
              backgroundColor: `${getStatusColor(text)}44`,
            }}
          >
            {text}
          </div>
        );
      },
    },
    {
      title: "Actions",
      render: (text: string, record: any, index: number) => (
        <div style={{ display: "flex", gap: 12 }}>
          <Button
            type="primary"
            disabled={record.status.toLowerCase() !== "pending"}
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/edit-order/${record.id}`);
            }}
          >
            Edit
          </Button>
          {/* <Button danger style={{ backgroundColor: '#f5222d' }} onClick={(e) => {
            e.stopPropagation();
            setdeleteSelectedId(record.order_id);
            setdeleteOpen(true);
          }}>Delete</Button> */}
        </div>
      ),
    },
  ];

  const handleCreate = () => {
    navigate("/create-order");
  };

  const filters = useGetStatusCount(statuses?.data.data);

  useEffect(() => {
    if (searchText) {
      const _data = orders?.data.filter(
        (item: any) =>
          item.product?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.startingDate
            .toString()
            ?.toLowerCase()
            .includes(searchText.toLowerCase()) ||
          item.dueDate
            .toString()
            ?.toLowerCase()
            .includes(searchText.toLowerCase()) ||
          item.orderAmount
            .toString()
            ?.toLowerCase()
            .includes(searchText.toLowerCase()) ||
          item.status?.toLowerCase().includes(searchText.toLowerCase()),
      );
      setTableData(_data);
    } else {
      if (orders && orders.data) {
        setTableData(orders.data);
      }
    }
  }, [orders, searchText]);

  useEffect(() => {
    if (selectedFilterIndex !== 0) {
      setSelectedStatus(filters[selectedFilterIndex].label);
      const _tableData = orders?.data.filter((item: any) =>
        item.status?.toLowerCase().includes(selectedStatus?.toLowerCase()),
      );

      setTableData(_tableData);
    } else {
      setSelectedStatus(undefined);
    }
  }, [selectedFilterIndex]);

  return (
    <>
      <div className="hidden md:block px-[50px]">
        <TableFilter
          filters={filters}
          setSelectedFilterIndex={setSelectedFilterIndex}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: 80,
            backgroundColor: "#EEF3F8",
            borderRadius: 8.4,
            marginTop: 25,
            marginBottom: 12,
          }}
        >
          <TableAction
            setSearchText={setSearchText}
            onCreateNew={handleCreate}
          />
        </div>
        <Table
          style={{
            cursor: "pointer",
            position: "relative",
            zIndex: 100,
            overflowY: "hidden",
          }}
          scroll={{ y: 600 }}
          onRow={(record, index) => {
            return {
              onClick: (event) => {
                navigate(`/my-orders/${record.id}`);
              },
            };
          }}
          dataSource={tableData}
          columns={ordersColumn}
          loading={isLoading}
        />
      </div>
      <div className="w-full grid grid-col divide-y-2 divide-green-400 md:hidden px-2 mb-4">
        <div className="text-white sticky top-0">
          <Input
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search"
            style={{ backgroundColor: "#08453E", color: "white", height: 40 }}
          />
        </div>
        {tableData?.map((item: any) => (
          <div
            className="flex justify-between items-center py-2"
            onClick={() => navigate(`/my-orders/${item.id}`)}
          >
            <div className="flex flex-col gap-1">
              <div className="flex gap-4 font-bold text-xl text-white">
                <div>{item.product}</div>
                <div>({item.orderAmount} qt)</div>
              </div>
              <div className="text-gray-300">{`${item.startingDate} - ${item.dueDate}`}</div>
              <div style={{ color: getStatusColor(item.status) }} className="">
                {item.status}
              </div>
            </div>
            <Popover
              placement="bottomLeft"
              title={<div style={{ color: "black" }}>Actions</div>}
              content={
                <div style={{ color: "black", width: 200 }}>
                  <div
                    onClick={(e) => {
                      if (item.status.toLowerCase() === "pending") {
                        e.stopPropagation();
                        navigate(`/edit-order/${item.id}`);
                      }
                    }}
                    style={{
                      display: "flex",
                      gap: 12,
                      alignItems: "center",
                      borderBottom: "1px solid #eee",
                      paddingBottom: 5,
                      marginTop: 15,
                      cursor: "pointer",
                    }}
                  >
                    <div>Edit</div>
                  </div>
                </div>
              }
            >
              <MoreOutlined className="text-white" />
            </Popover>
            <FloatButton
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleCreate}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default OffTakerOrdersTable;
